/** @module toxi.THREE */
module.exports = {
  ToxiclibsSupport: require('./THREE/ToxiclibsSupport')
};